(() => {
  document.addEventListener("DOMContentLoaded", () => {

    const theme = new URLSearchParams(window.location.search).get("theme");

    if (!theme) return;

    const targetAlt = `cover-${theme}`.toLowerCase();

    const targetImage = [...document.querySelectorAll(".product__media img")]
      .find(img => (img.alt || "").toLowerCase() === targetAlt);

    if (!targetImage) return;

    const mediaContainer = targetImage.closest("[data-media-id]");

    if (!mediaContainer) return;

    const mediaId = mediaContainer.dataset.mediaId;

    const gallery = document.querySelector("media-gallery");

    if (!gallery || typeof gallery.setActiveMedia !== "function") return;

    // prepend image and thumbnail without animation
    gallery.setActiveMedia(mediaId, true, true);

    // Optional: remove only the theme parameter
    const url = new URL(window.location.href);
    url.searchParams.delete("theme");
    history.replaceState({}, "", url);

  });
})();